import { useNavigate } from 'react-router-dom'

import { InputSearch } from '@components/Inputs/InputSearch'

import { CancelLabel, Container, SearchBox } from './styles'

export function SearchHeader() {
  const navigate = useNavigate()

  return (
    <Container>
      <SearchBox>
        <InputSearch />
        <CancelLabel onClick={() => navigate(-1)}>Cancel</CancelLabel>
      </SearchBox>
    </Container>
  )
}
